import axios from "axios";
import { useQuery } from "react-query";
import { configUrl } from "../config";

export default function useGetAssignedTests(userId, testStatus, targetAudience, searchValue, page, pageSize) {

  return useQuery(["assignedTests", userId], async () => {

    console.log("userId", userId);
    let searchVals;
    if (!userId) {
      return;
    }
    if (searchValue === '') {
      searchVals = null
    } else {
      searchVals = searchValue
    }

    let response = await axios.get(
      `${configUrl.AssessmentServer}/api/Tests/getAssignedTests/${page}/${pageSize}/${userId}/${testStatus}/${targetAudience}?testName=${searchVals}`
    );
    return response.data["$values"];
  },
    {
      staleTime: 1000 * 60 * 5,
    });
}

